<template>
    <div class="tavar">
        <div class="tavar__one">
            <h2 class="sec__title tavar__one">MASHHUR TOVARLAR</h2>
            <swiper class="tavar__one-info mySwiper"
            :slidesPerView="5"
            :spaceBetween="10"
            :slidesPerGroup="1"
            :loop="false"
            :loopFillGroupWithBlank="true"
            :pagination="{
                clickable: true,
                dynamicBullets: true,
            }"
            :breakpoints="{
                '0': {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                '400': {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                '580': {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                '650': {
                    slidesPerView: 3,
                    spaceBetween: 5
                },
                '700': {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                '800': {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                '900': {
                    slidesPerView: 3,
                    spaceBetween: 25
                },
                '1000': {
                    slidesPerView: 3,
                    spaceBetween: 50
                },
                '1100': {
                    slidesPerView: 4,
                    spaceBetween: 10
                },
                '1200': {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                '1400': {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                '1500': {
                    slidesPerView: 5,
                    spaceBetween: 10
                },
            }"
            :navigation="true"
            :modules="modules"
            >
                <swiper-slide class="tavar__one-info__card" v-for="(one,i) in tOne" :key="i">
                    <img :src="one.img" alt="">
                    <h2>{{one.title}}</h2>
                    <div class="tavar__one-info__card-price">
                        <span>{{one.price * one.amount}}</span>Sum
                    </div>
                    <div class="tavar__one-info__card-info" v-if="one.amountBool">
                        <button class="tavar__one-info__card-info__btn" @click="modalInfo(one.img,one.title,one.price,)">КУПИТЬ</button>
                        <div class="tavar__one-info__card-info__imgs">
                            <img v-if="one.heartFill" src="../../assets/img/card__heart1.svg" alt="" @click="addHeart(one.id,one.img,one.title,one.price)">
                            <img v-else class="tavar__one-info__card-info__imgs-heart" src="../../assets/img/heart.svg" alt=""
                            @click="$emit('heartFill',one.id)">
                            <img src="../../assets/img/card__shop.svg" alt="" @click="addCart(i,one.id,one.img,one.title,one.price,one.amount)">
                        </div>
                    </div>
                    <div class="tavar__one-info__card-summa" v-else>
                        <span @click="amounMath('-',i,one.id)">-</span>
                        <p>{{one.amount}}</p>
                        <span @click="amounMath('+',i,one.id)">+</span>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper";
export default {
    data() {
        return {
            price: 200000,
            amountBool:true,
        }
    },
    props: {
        tOne: Array,
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        return {
            modules: [Pagination, Navigation],
        };
    },
    methods: {
        addCart(i,id,img,title,price,amount){
            this.tOne.forEach((one,index) => {
                if (i == index) {
                    one.amountBool = false
                }
            });
            this.$emit('addCart',{
                id: id,
                img: img,
                title: title,
                price: price,
                amount: amount
            })
        },
        amounMath(plusOrMinus,i,id){
            this.tOne.forEach((one,index) => {
                if (i == index) {
                    if (plusOrMinus == '-') {
                        if (one.amount > 1) {
                            one.amount--
                            this.$emit('tMinus',{
                                id: id,
                                amount: one.amount
                            })
                        }
                        else{
                            one.amountBool = true
                            this.$emit('delCart',id)
                        }
                    }
                    else if (plusOrMinus == '+') {
                        one.amount++
                        this.$emit('tPlus',{
                            id: id,
                            amount: one.amount
                        })
                    }
                }
            });
        },
        addHeart(id,img,title,price){
            this.$emit('addHeart',{
                id: id,
                img: img,
                title: title,
                price: price
            })
        },
        modalInfo(img,title,price,){
            this.$emit('modalBool',{
                bool:true,
                obj:{
                    img:img,
                    title:title,
                    price:price
                }
            })
        }
    },
}
</script>
<style lang="">
    
</style>